import http from '../http';

import { observable, action, makeObservable,runInAction } from "mobx";

class PackageStore {
  packages = [];
  currentPackage = null;

  constructor() {
    makeObservable(this, {
      packages: observable,
      currentPackage: observable,
      fetchPackages: action,
      fetchPackage: action,
      createPackage: action,
      updatePackage: action,
      deletePackage: action,
    });
  }

  fetchPackages = () => {
    http.get('/user/packages')
      .then(response => {
        runInAction(() => {
          this.packages = response.data;
        });
      })
      .catch(() => {});
  }

  fetchPackage = (id) => {
    return http.get(`/user/packages/${id}`).then(response => {
      runInAction(() => {
        this.currentPackage = response.data.package;
      });
    });
  }

  createPackage = (data) => {
    return http.post('/user/packages/create', data);
  }

  updatePackage = (id, data) => {
    return http.put(`/user/packages/${id}`, data);
  }

  deletePackage = (id) => {
    http.delete(`/user/packages/${id}`).then(() => {
      this.fetchPackages();
    }).catch(() => {});
  }
}

const packageStore = new PackageStore();

export {packageStore}
